import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {
	LockedAccount,
	LoginAttemptsService,
} from '@lmc-app/services/login-attempts/login-attempts.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { LmcDialogComponent } from '@lmc-app/shared/components/dialog/lmc-dialog.component';
import { DateUtil } from '@lmc-app/shared/utils/date.util';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { NgIf } from '@angular/common';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import {
	MatTable,
	MatColumnDef,
	MatHeaderCellDef,
	MatHeaderCell,
	MatCellDef,
	MatCell,
	MatHeaderRowDef,
	MatHeaderRow,
	MatRowDef,
	MatRow,
} from '@angular/material/table';

@Component({
	selector: 'app-locked-accounts',
	templateUrl: './locked-accounts.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: ['./locked-accounts.component.scss'],
	imports: [
		MatButton,
		MatIcon,
		NgIf,
		MatProgressSpinner,
		MatTable,
		MatColumnDef,
		MatHeaderCellDef,
		MatHeaderCell,
		MatCellDef,
		MatCell,
		MatHeaderRowDef,
		MatHeaderRow,
		MatRowDef,
		MatRow,
	],
})
export class LockedAccountsComponent implements OnInit {
	lockedAccounts: LockedAccount[] = [];
	displayedColumns: string[] = [
		'username',
		'ipAddress',
		'firstAttemptAt',
		'lastAttemptAt',
		'lockedUntil',
		'actions',
	];
	isLoading = false;
	protected readonly DateUtil = DateUtil;

	constructor(
		private loginAttemptsService: LoginAttemptsService,
		private snackBar: MatSnackBar,
		private dialog: MatDialog
	) {}

	ngOnInit(): void {
		this.loadLockedAccounts();
	}

	loadLockedAccounts(): void {
		this.isLoading = true;
		this.loginAttemptsService.getLockedAccounts().subscribe({
			next: (response) => {
				this.lockedAccounts = response.data;
				this.isLoading = false;
			},
			error: (error) => {
				console.error('Error loading locked accounts:', error);
				this.snackBar.open('Failed to load locked accounts', 'Close', {
					duration: 3000,
					horizontalPosition: 'right',
					verticalPosition: 'top',
				});
				this.isLoading = false;
			},
		});
	}

	unlockAccount(account: LockedAccount): void {
		const dialogRef = this.dialog.open(LmcDialogComponent, {
			data: {
				title: 'Unlock Account',
				content: `Are you sure you want to unlock account "${account.username}" from IP ${account.ipAddress}?`,
				positiveButtonText: 'Unlock',
				negativeButtonText: 'Cancel',
			},
		});

		dialogRef.afterClosed().subscribe((result) => {
			if (result === true) {
				this.loginAttemptsService.unlockAccount(account.uuid).subscribe({
					next: (response) => {
						if (response.success) {
							this.snackBar.open(response.message, 'Close', {
								duration: 3000,
								horizontalPosition: 'right',
								verticalPosition: 'top',
							});
							// Reload the list after successful unlock
							this.loadLockedAccounts();
						}
					},
					error: (error) => {
						console.error('Error unlocking account:', error);
						this.snackBar.open('Failed to unlock account', 'Close', {
							duration: 3000,
							horizontalPosition: 'right',
							verticalPosition: 'top',
						});
					},
				});
			}
		});
	}
}
